import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigationBlocker } from 'router/NavigationBlockerProvider';

const Item = ({ active = false, path, text }) => {
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const { navigateSafely } = useNavigationBlocker();
  const regex = /import/i;

  useEffect(() => {
    if (regex.test(location.pathname) && text === 'navigation.import') {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [regex]);

  const handleClick = (e) => {
    const blocked = navigateSafely(path);
    if (blocked) {
      e.preventDefault();
    }
  };

  return (
    <Link title={t(text)} to={path} onClick={handleClick}>
      <div className={`item ${active ? ' active' : ''} ${isActive ? ' active' : ''}`}>
        <span>{t(text)}</span>
      </div>
    </Link>
  );
};

Item.propTypes = {
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default Item;
